import { parseApiErrorMessage } from "@services/api";

import { buildQueryArray, separateByComma } from "../utility/utilityFunctions";

/* Deprecated */

const statusMap = {
  "order-set-variants": "order-set-status",
  "history-items": "order-status",
  "order-variants-report": "order-status",
};

const dateMap = {
  "order-set-history": "submitted-at-range",
  "order-set-variants": "order-set-submitted-at-range",
  "history-items": "order-submitted-at-range",
  "order-variants-report": "order-submitted-at-range",
};

const orderSetHistoryTypes = [
  "order-set-history",
  "order-variants-report",
  "order-set-variants",
];

const handleHistoryItemStatus = (filterObject) => {
  if (filterObject.status === "order-canceled") {
    return "filter[is-order-canceled]=true";
  } else if (filterObject.status === "compliance-canceled") {
    return "filter[is-compliance-canceled]=true";
  } else if (filterObject.status === "destroyed") {
    return "filter[is-destroyed]=true";
  } else if (filterObject.status === "not-ordered") {
    return "filter[not-ordered]=true";
  } else {
    return `filter[order-status]=${filterObject.status}`;
  }
};

const handleItemOrderType = (filterObject) => {
  if (filterObject.itemOrderType === "inventory") {
    return "filter[is-inventory]=true";
  } else if (filterObject.itemOrderType === "on-demand") {
    return "filter[is-on-demand]=true";
  } else {
    const dateArray = filterObject.itemOrderType.split("-");
    return `filter[order-month][month]=${
      dateArray[0]
    }&filter[order-month][year]=${dateArray[1]}`;
  }
};

export const buildFilters = (
  filterObject,
  uniqueFilter,
  sortString,
  urlBase,
  type
) => {
  const channelString = filterObject.channel
    ? `filter[channel]=${filterObject.channel}`
    : "";
  const warehouseString =
    filterObject.warehouse && filterObject.warehouse !== "all"
      ? `filter[warehouse]=${filterObject.warehouse}`
      : "";
  const statusString =
    filterObject.status && filterObject.status.length > 0
      ? filterObject.status === "all"
        ? ""
        : filterObject.status === "sent-to-flow"
          ? "filter[po-sent-to-flow]=true"
          : filterObject.status === "not-invoiced"
            ? "filter[not-invoiced]=true"
            : type === "reports"
              ? handleHistoryItemStatus(filterObject)
              : filterObject.status.includes("bid-")
                ? `${
                    filterObject.status === "bid-awarded"
                      ? `filter[bid-status]=${
                          filterObject.status.split("-")[1]
                        }&filter[status]=awarded`
                      : `filter[bid-status]=${filterObject.status.split("-")[1]}`
                  }`
                : `filter[${statusMap[type] || "status"}]=${
                    filterObject.status === "all-orders"
                      ? "in-progress,submitted"
                      : filterObject.status
                  }`
      : "";

  const orderNumString =
    filterObject.orderNum && filterObject.orderNum.length > 0
      ? `filter[order-number]=${filterObject.orderNum}`
      : "";

  const itemOrderTypeString =
    filterObject.itemOrderType && filterObject.itemOrderType !== "all"
      ? handleItemOrderType(filterObject)
      : "";
  const orderTypeString =
    filterObject.orderType && filterObject.orderType !== "all"
      ? `filter[order-type]=${filterObject.orderType}`
      : "";

  const dateString =
    filterObject.fromDate &&
    filterObject.toDate &&
    filterObject.status !== "draft"
      ? (filterObject.status === "submitted" &&
          orderSetHistoryTypes.includes(type)) ||
        !orderSetHistoryTypes.includes(type)
        ? `filter[${dateMap[type] ?? "submitted-at-range"}]=${
            filterObject.fromDate
          } - ${filterObject.toDate}`
        : ""
      : "";

  const poSubmittedDateRangeString =
    filterObject.poSubmittedFromDate && filterObject.poSubmittedToDate
      ? `filter[submitted-at-range]=${filterObject.poSubmittedFromDate} - ${filterObject.poSubmittedToDate}`
      : "";
  const poInMarketDateRangeString =
    filterObject.poInMarketFromDate && filterObject.poInMarketToDate
      ? `filter[in-market-date-range]=${filterObject.poInMarketFromDate} - ${filterObject.poInMarketToDate}`
      : "";
  const poStatusString =
    filterObject.poStatus && filterObject.poStatus !== "all"
      ? `filter[status]=${filterObject.poStatus}`
      : "";

  const seqString =
    filterObject.itemNumber && filterObject.itemNumber.length > 0
      ? `filter[item-number]=${filterObject.itemNumber}`
      : "";
  const itemNumbersString =
    filterObject.itemNumbers && filterObject.itemNumbers.length > 0
      ? buildQueryArray("item-numbers", filterObject.itemNumbers)
      : "";
  const addressString =
    filterObject.address && filterObject.address.length > 0
      ? `filter[address-ids]=${separateByComma(filterObject.address, "id")}`
      : "";
  const userString =
    filterObject.user && filterObject.user.length > 0
      ? `filter[user-ids]=${separateByComma(filterObject.user, "id")}`
      : "";
  const purchaserString =
    filterObject.purchaser && filterObject.purchaser.length > 0
      ? `filter[purchaser-ids]=${separateByComma(filterObject.purchaser, "id")}`
      : "";
  const progString =
    filterObject.program && filterObject.program.length > 0
      ? `filter[program-ids]=${separateByComma(filterObject.program, "id")}`
      : "";
  const brandString =
    filterObject.brand && filterObject.brand.length > 0
      ? `filter[brand-ids]=${separateByComma(filterObject.brand, "id")}`
      : "";
  const itemTypeString =
    filterObject.itemType && filterObject.itemType.length > 0
      ? `filter[item-type-ids]=${separateByComma(filterObject.itemType, "id")}`
      : "";
  const buString =
    filterObject.bu && filterObject.bu.length > 0
      ? `filter[business-unit-names]=${separateByComma(
          filterObject.bu,
          "name"
        )}`
      : "";

  const supplierString =
    filterObject.supplier && filterObject.supplier.length > 0
      ? `filter[supplier-ids]=${separateByComma(filterObject.supplier, "id")}`
      : "";
  const ruleTypeString =
    filterObject.ruleType && filterObject.ruleType.length > 0
      ? filterObject.ruleType === "all"
        ? ""
        : `filter[type]=${filterObject.ruleType}`
      : "";
  const isAccoladeString = filterObject.isAccolade
    ? filterObject.isAccolade === "yes"
      ? "filter[is-accolade]=true"
      : "filter[is-accolade]=false"
    : "";
  let isOrderableString = filterObject.isItemOrderable
    ? `filter[is-orderable]=true`
    : "";
  if (isOrderableString && filterObject.orderType === "on-demand") {
    isOrderableString += "&filter[is-orderable-for-on-demand]=true";
    isOrderableString += "&filter[is-on-national-coupon-programs]=false";
  }
  const isArchivedString =
    filterObject.isItemArchived !== null &&
    filterObject.isItemArchived !== undefined
      ? `filter[is-archived]=${filterObject.isItemArchived}`
      : "";
  const stateString =
    filterObject.stateIds && filterObject.stateIds.length > 0
      ? `filter[state-ids]=${separateByComma(filterObject.stateIds, "id")}`
      : "";
  const territoryString =
    filterObject.territory && filterObject.territory.length > 0
      ? `filter[territory-ids]=${separateByComma(filterObject.territory, "id")}`
      : "";
  const exclusiveTerritoryString =
    filterObject.exclusiveTerritory &&
    filterObject.exclusiveTerritory.length > 0
      ? `filter[exclusive-territory-ids]=${separateByComma(
          filterObject.exclusiveTerritory,
          "id"
        )}`
      : "";
  const currentTerritoryString = filterObject.currentTerritoryId
    ? `filter[territory-ids]=${filterObject.currentTerritoryId}`
    : "";
  const orderVariantIdString =
    filterObject.orderVariantIds && filterObject.orderVariantIds.length > 0
      ? `filter[ids]=${filterObject.orderVariantIds}`
      : "";
  const isPreOrderString = filterObject.isPreOrder
    ? "filter[is-pre-order]=true"
    : "";
  const isCanceledString =
    filterObject?.isCanceled === false ? "filter[is-canceled]=false" : "";
  const isPreOrderActiveString = filterObject.isPreOrderActive
    ? "filter[is-pre-order-active]=true"
    : "";
  const itemCommentAndSubTypeString =
    filterObject.itemCommentAndSubType &&
    filterObject.itemCommentAndSubType.length > 0
      ? `filter[item-comment-and-sub-type]=${filterObject.itemCommentAndSubType}`
      : "";
  const itemDescString =
    filterObject.itemDesc && filterObject.itemDesc.length > 0
      ? `filter[comment]=${filterObject.itemDesc}`
      : "";
  const focusMonthString =
    filterObject.focusMonth && filterObject.focusMonth.length > 0
      ? `filter[focus-month][month]=${filterObject.focusMonth}`
      : "";
  const focusYearString =
    filterObject.focusYear && filterObject.focusYear.length > 0
      ? `filter[focus-month][year]=${filterObject.focusYear}`
      : "";
  const orderMonthString =
    filterObject.orderMonth && filterObject.orderMonth.length > 0
      ? `filter[order-month][month]=${filterObject.orderMonth}`
      : "";
  const orderYearString =
    filterObject.orderYear && filterObject.orderYear.length > 0
      ? `filter[order-month][year]=${filterObject.orderYear}`
      : "";
  const orderWindowMonthYearString = filterObject.orderWindowMonthYear
    ? `filter[order-window-month-year]=${filterObject.orderWindowMonthYear["formattedDate"]}`
    : "";
  const orderMonthYearsString = filterObject.orderMonthYears
    ? `filter[order-month-years]=${filterObject.orderMonthYears}`
    : "";
  const inMarketYearString =
    filterObject.inMarketYear && filterObject.inMarketYear.length > 0
      ? `filter[in-market-years]=${separateByComma(
          filterObject.inMarketYear,
          "id"
        )}`
      : "";
  const inMarketYearsString =
    filterObject.inMarketYears?.length > 0
      ? `filter[in-market-years]=${separateByComma(filterObject.inMarketYears)}`
      : "";
  const programTypeString =
    filterObject.programType?.length > 0
      ? `filter[program-types]=${separateByComma(
          filterObject.programType,
          "description"
        )}`
      : "";
  const inMarketMonthYearsString =
    filterObject.inMarketMonthYears?.length > 0
      ? `filter[in-market-month-years]=${separateByComma(
          filterObject.inMarketMonthYears.map((o) => o?.id || o)
        )}`
      : "";
  const inMarketMonthsString =
    filterObject.inMarketMonths?.length > 0
      ? `filter[in-market-months]=${separateByComma(
          filterObject.inMarketMonths
        )}`
      : "";
  const qtyNotZeroString = filterObject.qtyNotZero
    ? "filter[qty-not-zero]=true"
    : "";
  const pageSizeString = filterObject.pageSize
    ? `page[size]=${filterObject.pageSize}`
    : "";
  const excludesSupplierString =
    filterObject.excludedSupplier && filterObject.excludedSupplier.length > 0
      ? `filter[excludes-supplier]=${filterObject.excludedSupplier}`
      : "";
  const poInvoiceNumberReferenceString =
    filterObject.poInvoiceNumber && filterObject.poInvoiceNumber.length > 0
      ? `filter[invoice-number]=${filterObject.poInvoiceNumber}`
      : "";
  const poExternalSapIdReferenceString =
    filterObject.poExternalSapId && filterObject.poExternalSapId.length > 0
      ? `filter[external-sap-id]=${filterObject.poExternalSapId}`
      : "";
  const supplierReferenceString =
    filterObject.supplierReference && filterObject.supplierReference.length > 0
      ? `filter[supplier-reference]=${filterObject.supplierReference}`
      : "";
  const c2mOrderDateString =
    filterObject.c2mOrderDateFrom && filterObject.c2mOrderDateTo
      ? `filter[order-date-range]=${filterObject.c2mOrderDateFrom} - ${filterObject.c2mOrderDateTo}`
      : "";
  const c2mInMarketDateString =
    filterObject.c2mInMarketDateFrom && filterObject.c2mInMarketDateTo
      ? `filter[in-market-date-range]=${filterObject.c2mInMarketDateFrom} - ${filterObject.c2mInMarketDateTo}`
      : "";
  const c2mTerritoryString =
    filterObject.c2mTerritory && filterObject.c2mTerritory.length > 0
      ? `filter[territory]=${filterObject.c2mTerritory}`
      : "";
  const c2mProgramString =
    filterObject.c2mProgramName && filterObject.c2mProgramName.length > 0
      ? `filter[program-name]=${filterObject.c2mProgramName}`
      : "";
  const c2mBrandsString =
    filterObject.c2mBrands && filterObject.c2mBrands.length > 0
      ? `filter[brands]=${filterObject.c2mBrands}`
      : "";
  const c2mBusinessUnitString =
    filterObject.c2mBusinessUnit && filterObject.c2mBusinessUnit.length > 0
      ? `filter[business-unit]=${filterObject.c2mBusinessUnit}`
      : "";
  const c2mDistributorString =
    filterObject.c2mDistributor && filterObject.c2mDistributor.length > 0
      ? `filter[distributor-or-abn]=${filterObject.c2mDistributor}`
      : "";
  const c2mNameString =
    filterObject.c2mName && filterObject.c2mName.length > 0
      ? `filter[name]=${filterObject.c2mName}`
      : "";
  const c2mProgramThemeString =
    filterObject.c2mProgramTheme && filterObject.c2mProgramTheme.length > 0
      ? `filter[program-theme]=${filterObject.c2mProgramTheme}`
      : "";
  const c2mItemTypeString =
    filterObject.c2mItemType && filterObject.c2mItemType.length > 0
      ? `filter[item-type]=${filterObject.c2mItemType}`
      : "";
  const programNameString =
    filterObject.programName && filterObject.programName.length > 0
      ? `filter[program-name]=${filterObject.programName}`
      : "";
  const programIdString =
    filterObject.programId && filterObject.programId.length > 0
      ? `filter[program-id-or-anaplan-code]=${filterObject.programId}`
      : "";
  const workfrontString =
    filterObject.workfrontId && filterObject.workfrontId.length > 0
      ? `filter[workfront-id]=${filterObject.workfrontId}`
      : "";
  const couponString =
    filterObject.couponBarcodeId && filterObject.couponBarcodeId.length > 0
      ? `filter[coupon-barcode-id]=${filterObject.couponBarcodeId}`
      : "";

  const supplierQuoteIdString =
    filterObject.supplierQuoteId && filterObject.supplierQuoteId.length > 0
      ? `filter[supplier-quote-number]=${filterObject.supplierQuoteId}`
      : "";

  const infoCompleteString =
    filterObject.infoComplete !== undefined
      ? `filter[info-complete]=${filterObject.infoComplete}`
      : "";

  const isCouponString =
    filterObject.isCoupon !== undefined
      ? `filter[is-coupon]=${filterObject.isCoupon}`
      : "";

  const hasItemNumberString =
    filterObject.hasItemNumber !== undefined
      ? `filter[has-item-number]=${filterObject.hasItemNumber}`
      : "";
  const isActiveString =
    filterObject.isActive !== undefined
      ? `filter[is-active]=${filterObject.isActive}`
      : "";
  const rtaDeploymentString =
    filterObject.rtaDeployment !== undefined
      ? `filter[rta-deployment]=${filterObject.rtaDeployment}`
      : "";
  const nameString = filterObject.name
    ? `filter[name]=${filterObject.name}`
    : "";

  const ocmIdsString = filterObject.ocmIds?.length
    ? `filter[order-calendar-month-ids]=${filterObject.ocmIds}`
    : "";
  const orderWindowTypeString = filterObject.orderWindowType?.length
    ? `filter[order-window-type]=${filterObject.orderWindowType}`
    : "";

  const activeProgramsString = filterObject.activePrograms
    ? `filter[active-programs]=true`
    : "";
  const isActivatedString =
    filterObject.isActivated !== undefined
      ? `filter[is-activated]=${filterObject.isActivated}`
      : "";

  const programTypeId =
    filterObject.programTypeId !== undefined
      ? `filter[program-type-id]=${filterObject.programTypeId}`
      : "";

  const codeOrName = filterObject.codeOrName
    ? `filter[code-or-name]=${filterObject.codeOrName}`
    : "";

  const orderVariantIdsString =
    filterObject.orderVariantIds?.length > 0
      ? `filter[order-variant-ids]=${filterObject.orderVariantIds.join(",")}`
      : "";

  const anaplanCodeString =
    filterObject.anaplanCode?.length > 0
      ? `filter[anaplan-code]=${filterObject.anaplanCode}`
      : "";
  const budgetIdString =
    filterObject.budgetId?.length > 0
      ? `filter[budget-id]=${filterObject.budgetId}`
      : filterObject.budgets?.length > 0
        ? `filter[budget-id]=${separateByComma(filterObject.budgets, "id")}`
        : "";
  const noBudgetsString = filterObject.noBudgets
    ? `filter[no-budgets]=true`
    : "";

  const anaplanProgramTypeString =
    filterObject.anaplanProgramType && filterObject.anaplanProgramType !== "all"
      ? `filter[anaplan-program-type]=${filterObject.anaplanProgramType}`
      : "";

  const queryArray = [
    uniqueFilter,
    channelString,
    warehouseString,
    itemOrderTypeString,
    itemNumbersString,
    orderNumString,
    orderTypeString,
    statusString,
    dateString,
    poSubmittedDateRangeString,
    poInMarketDateRangeString,
    poStatusString,
    seqString,
    addressString,
    progString,
    brandString,
    itemTypeString,
    buString,
    userString,
    purchaserString,
    supplierString,
    ruleTypeString,
    isAccoladeString,
    isOrderableString,
    isArchivedString,
    stateString,
    currentTerritoryString,
    territoryString,
    exclusiveTerritoryString,
    orderVariantIdString,
    isPreOrderActiveString,
    isPreOrderString,
    isCanceledString,
    itemCommentAndSubTypeString,
    itemDescString,
    focusMonthString,
    focusYearString,
    orderMonthString,
    inMarketYearString,
    programTypeString,
    inMarketMonthYearsString,
    inMarketYearsString,
    orderYearString,
    orderWindowMonthYearString,
    orderMonthYearsString,
    qtyNotZeroString,
    c2mOrderDateString,
    c2mInMarketDateString,
    c2mTerritoryString,
    c2mProgramString,
    c2mBrandsString,
    c2mBusinessUnitString,
    c2mDistributorString,
    c2mNameString,
    c2mProgramThemeString,
    c2mItemTypeString,
    supplierQuoteIdString,
    programNameString,
    workfrontString,
    programIdString,
    couponString,
    pageSizeString,
    excludesSupplierString,
    poInvoiceNumberReferenceString,
    poExternalSapIdReferenceString,
    supplierReferenceString,
    infoCompleteString,
    isCouponString,
    hasItemNumberString,
    isActiveString,
    rtaDeploymentString,
    nameString,
    inMarketMonthsString,
    ocmIdsString,
    orderWindowTypeString,
    activeProgramsString,
    sortString,
    programTypeId,
    isActivatedString,
    codeOrName,
    orderVariantIdsString,
    anaplanCodeString,
    budgetIdString,
    noBudgetsString,
    anaplanProgramTypeString,
  ];

  const queryStringAppend = queryArray
    .filter((query) => query.length !== 0)
    .join("&");
  const filterPreCursor = queryStringAppend.length !== 0 ? "?" : "";

  const queryString = urlBase + filterPreCursor + queryStringAppend;
  return queryString;
};

export const handleErrors = (err) => {
  return parseApiErrorMessage(err);
};
